import type { ParallaxSvgSpec } from '../../../../config/atmosphere/effectLayer.types';
import { placeWorldShape, type ShapePlacement } from './worldShapeKit';

/** Taller landscape frames use the same display height, retaining intentional
 * feature widths. Trees and buildings keep small, recognizable proportions. */
function routeTile(height: number, shapes: readonly ShapePlacement[], bank: string): ParallaxSvgSpec {
  return { tile: { viewBoxWidth: 2400, viewBoxHeight: height,
    path: [bank, ...shapes.map(shape => placeWorldShape(...shape))].join(' ') } };
}

export const OPENING_ROUTE_DEPTH_HEIGHTS = { firstField: 1100, pigBeach: 1320 } as const;

export const OPENING_ROUTE_DEPTH_BACKDROPS = {
  // Chalk shoulders, a small oak and one distant farm roof leave most of the
  // moonrise route in open sky. The top shelf reaches world y605 at horizon1370.
  firstField: routeTile(OPENING_ROUTE_DEPTH_HEIGHTS.firstField, [
    ['mesa', 120, 1100, 800, 850], ['mesa', 1420, 1100, 650, 720],
    ['oak', 420, 335, 130, 100], ['gable', 1670, 452, 110, 75],
  ], 'M0 1100V980Q170 980 330 965L610 965Q800 992 1010 980'
    + 'L1280 980Q1480 950 1700 970L2070 970Q2240 980 2400 980V1100Z'),
  // Separate coastal stacks rise behind the existing palm/headland planes.
  // The original Coil Light remains in its own unchanged layer above this one.
  // Palms are only110–120px wide, rather than stretching a tree up the cliff.
  pigBeach: routeTile(OPENING_ROUTE_DEPTH_HEIGHTS.pigBeach, [
    ['mesa', 230, 1320, 520, 1180], ['mesa', 1470, 1320, 460, 950],
    ['palm', 430, 258, 110, 150], ['palm', 1620, 465, 120, 160],
  ], 'M0 1320V1240Q220 1240 410 1228L690 1228Q900 1250 1140 1240'
    + 'L1390 1240Q1600 1220 1850 1235L2140 1235Q2290 1240 2400 1240V1320Z'),
} satisfies Record<keyof typeof OPENING_ROUTE_DEPTH_HEIGHTS, ParallaxSvgSpec>;
